import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_PROFILE_RESET = 'POST_PROFILE_RESET';
export const POST_PROFILE_LOADING = 'POST_PROFILE_LOADING';
export const POST_PROFILE_SUCCESS = 'POST_PROFILE_SUCCESS';
export const POST_PROFILE_REJECT = 'POST_PROFILE_REJECT';

//* ACTIONS ------------------------------------------------
export const postProfileReset = () => ({ type: POST_PROFILE_RESET });
export const postProfileLoading = () => ({ type: POST_PROFILE_LOADING });
export const postProfileSuccess = (payload) => ({ type: POST_PROFILE_SUCCESS, payload });
export const postProfileReject = (payload) => ({ type: POST_PROFILE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postProfileRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/Profiles/web/Post`, options);
};


